<template>
  <section class="sidearm-mm-theme bg-black relative" data-anchor="theme">
    <div class="sidearm-mm-theme__inner relative">
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__bg absolute w-100 h-100"
        id="sidearm-mm-theme-bg"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/busted/bg.jpg"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/busted/bg_mobile.jpg" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__court absolute w-100 h-100"
        id="sidearm-mm-theme-court"
      >
        <div class="w-100 h-100">
          <picture>
            <source
              srcset="~@/assets/themes/busted/court.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/busted/court_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__x-top absolute w-100 h-100"
        id="sidearm-mm-theme-x-top"
      >
        <div class="h-100 w-100">
          <div class="sidearm-mm-theme__x-container">
            <picture>
              <source
                srcset="~@/assets/themes/busted/x_pattern.png"
                media="(min-width: 1025px)"
              />
              <img src="~@/assets/themes/busted/x_pattern_mobile.png" />
            </picture>
          </div>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__x-bottom absolute w-100 h-100"
        id="sidearm-mm-theme-x-bottom"
      >
        <div class="h-100 w-100">
          <div class="sidearm-mm-theme__x-container">
            <picture>
              <source
                srcset="~@/assets/themes/busted/x_pattern.png"
                media="(min-width: 1025px)"
              />
              <img src="~@/assets/themes/busted/x_pattern_mobile.png" />
            </picture>
          </div>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__title absolute w-100 h-100"
        id="sidearm-mm-theme-title"
      >
        <div class="h-100 w-100">
          <div class="sidearm-mm-theme__title-text">
            Busted
          </div>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__cloud-top absolute w-100"
        id="sidearm-mm-theme-cloud-top"
      >
        <div class="w-100">
          <picture>
            <source
              srcset="~@/assets/themes/busted/cloud_top.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/busted/cloud_top_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__cloud-bottom absolute w-100"
        id="sidearm-mm-theme-cloud-bottom"
      >
        <div class="w-100 h-100">
          <picture>
            <source
              srcset="~@/assets/themes/busted/cloud_bottom.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/busted/cloud_bottom_mobile.png" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__divider absolute w-100 h-100"
        id="sidearm-mm-theme-divider"
      >
        <div class="h-100 w-100">
          <div>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sidearm-mm-theme {
  &__inner {
    height: 300vh;
  }

  &__bg {
    text-align: center;
  }

  &__court {
    top: 0;
    left: 0;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-height: 60%;
      max-width: 50%;
    }
  }

  &__cloud-top {
    top: 0;
    left: 0;
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
    }
  }
  &__cloud-bottom {
    top: 0;
    left: 0;
    height: 100vh;
    img {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }

  &__x-top {
    .sidearm-mm-theme__x-container {
      position: absolute;
      top: 0;
      left: 12.5%;
      width: 10%;
      transform: translateY(-100%);
      &::after {
        position: absolute;
        right: 0;
        width: 200%;
        bottom: 0;
        height: 1px;
        content: "";
        background: $color-white;
        transform: translateY($spacer * 2);
        opacity: 0.5;
      }
    }
  }

  &__x-bottom {
    .sidearm-mm-theme__x-container {
      position: absolute;
      top: 0;
      right: 12.5%;
      width: 10%;
      transform: translateY(100%);
      &::after {
        position: absolute;
        right: 0;
        width: 200%;
        top: 0;
        height: 1px;
        content: "";
        background: $color-white;
        transform: translateY($spacer * -2);
        opacity: 0.5;
      }
    }
  }

  &__title-text {
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    width: 100%;
    white-space: nowrap;
    font-family: $font-abolition;
    font-size: 6rem;
    letter-spacing: 0.35em;
    padding-left: 0.35em;
    line-height: 1;
    font-weight: 400;
    color: transparent;
    -webkit-text-stroke: thin rgba(255, 255, 255, 0.8);
    transform: translate(0, -100%);
    @include responsive_text_rems(768, 1920, 48, 120, 12, 17);
  }
  &__divider {
    span {
      position: absolute;
      top: 0;
      left: 62.5%;
      transform: translate(-50%, -100vh);
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
      &::before {
        position: absolute;
        bottom: 100%;
        left: 50%;
        width: 1px;
        height: 300vh;
        content: "";
        background: $color-white;
      }
    }
  }
}

@media (max-width: #{$breakpoint-x-large}) {
  .sidearm-mm-theme {
    &__title-text {
      font-size: 3rem;
    }
  }
}
</style>
